import React, { useState } from "react";

const faqs = [
  {
    q: "How much does mobile app development cost in Dubai?",
    a: "The cost depends on your app features, design requirements, integrations, and technology choice. A simple MVP costs less than a large enterprise application with advanced features.",
  },
  {
    q: "How long does it take to build a mobile app?",
    a: "A basic app can take around 6 to 10 weeks, while complex applications may require several months depending on features and testing requirements.",
  },
  {
    q: "Do you develop both iOS and Android apps?",
    a: "Yes. We build native iOS apps, Android apps, and cross-platform applications based on your business goals.",
  },
  {
    q: "Do you build custom mobile apps for startups?",
    a: "Yes. We help startups create MVP applications that allow them to test ideas and launch faster.",
  },
  {
    q: "Can you build Arabic mobile applications?",
    a: "Yes. We create bilingual applications with Arabic RTL support for businesses targeting UAE customers.",
  },
  {
    q: "Do you provide app maintenance after launch?",
    a: "Yes. We provide ongoing maintenance, updates, and technical support after your app goes live.",
  },
  {
    q: "Do you work with businesses outside Dubai?",
    a: "Yes. We work with businesses across Dubai, Abu Dhabi, Sharjah, Ajman, and other UAE cities.",
  },
];

export default function Section12() {
  const [isOpen, setIsOpen] = useState(new Array(faqs.length).fill(false));

  const handleFaq = (index) => {
    setIsOpen((prev) => prev.map((item, idx) => (idx === index ? !item : false)));
  };

  return (
    <div className="w-full Section12 py-[35px] bg-[#F5F5F5]">
      <div className="container-1280 section12-container w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%]">
        <h2 className="text-[22px] md:text-[30px] font-bold leading-[28px] md:leading-[38px] text-center my-[0.67em] text-[#151515]">
          Frequently Asked Questions
        </h2>

        <div className="w-full md:w-[784px] p-5 md:p-[2%] mx-auto faq-container font-open leading-[21px]">
          {faqs.map((faq, index) => (
            <div
              key={faq.q}
              className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%] bg-white"
            >
              <div
                onClick={() => handleFaq(index)}
                className="question text-[#444444] cursor-pointer flex justify-between items-center"
              >
                {faq.q}
                <b className="text-[40px] text-[#cd2122] font-[300]">
                  {isOpen[index] ? "-" : "+"}
                </b>
              </div>
              <div className={`${isOpen[index] ? "block" : "hidden"} answer text-[#444444]`}>
                <br />
                <p className="mb-5">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
